var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_68254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4211 2.69679V1.81433C14.4211 1.08851 13.8328 0.5 13.1068 0.5C12.381 0.5 11.7925 1.08851 11.7925 1.81433V2.71712C12.6644 2.60115 13.5475 2.59431 14.4211 2.69679ZM20.8081 16.1522L20.8025 16.1557L20.7991 16.1578L17.3876 18.2265C17.4448 18.4184 17.4814 18.6157 17.4967 18.8154C17.514 19.0423 17.3441 19.2405 17.117 19.258L11.8289 19.6617C11.8182 19.6625 11.8076 19.6629 11.7969 19.6629C11.5754 19.6627 11.3936 19.4875 11.3852 19.266C11.3769 19.0446 11.545 18.8561 11.7661 18.8394L16.6004 18.4703C16.3352 17.5706 15.4781 16.9782 14.5427 17.0485L11.3256 17.2941C10.6867 17.3421 10.0455 17.2458 9.4491 17.0123L9.10521 16.8772C7.42627 16.2132 5.5188 16.5186 4.13139 17.6739L4.48494 22.305L4.97378 21.9736C5.49585 21.6189 6.13529 21.4807 6.75722 21.5884L12.3594 22.55C13.4257 22.6549 14.498 22.421 15.4236 21.881L22.4359 16.2353C21.9676 15.8608 21.3123 15.8272 20.8081 16.1522ZM5.80874 15.1066C4.91822 15.115 4.10039 14.6161 3.70054 13.8204L2.8962 12.1171H23.4984L22.6939 13.8204C22.2942 14.6161 21.4764 15.115 20.5859 15.1066H5.80874ZM0.5 16.5806L3.20577 16.374L3.73387 23.2936L1.02831 23.5001L0.5 16.5806ZM13.1977 3.45127C15.5797 3.45127 17.8143 4.31038 19.49 5.8653C21.0621 7.32419 21.9677 9.23065 22.0661 11.2923H4.32937C4.42782 9.23065 5.33344 7.32318 6.90548 5.8643C8.5812 4.30937 10.8158 3.45127 13.1977 3.45127Z",
    fill: "#D5DAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_68254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.6c453cefaa26ec5ab1d75d7767b6d06e.svg";
export { ForwardRef as ReactComponent };